import * as moment from 'moment';

import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { messages as i18n } from '@teem/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import * as Api from '@teem/constants/api';


export default class InvoiceTableSchema {
	containerContext: any;
	userInfo: any = (window as any).userInfo;
	keyColumn: string = 'uuid';
	serverUrl: string = `${Api.invoice.all}?is_draft=0`;
	headers: Array<object> = [
		{ "label": $localize`:@@ts.invoice_number:Invoice`, "thClass": "th-invoice_number" },
		{ "label": $localize`:@@ts.client:Client`, "thClass": "th-client" },
		{ "label": $localize`:@@ts.status:Status`, "thClass": "th-payment" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-invoice_date" },
		{ "label": $localize`:@@ts.amount:Amount`, "thClass": "th-amount" },
		// { "label": $localize`:@@ts.project_name:Project Name`, "thClass": "th-project" },		
		// { "label": $localize`:@@ts.paid_amount:Paid Amount`, "thClass": "th-amount" },
		// { "label": $localize`:@@ts.due:Due`, "thClass": "th-amount" },
		// { "label": $localize`:@@ts.status:Status`, "thClass": "th-status text-center" },
		// { "label": " ", "thClass": "th-record" },
		// { "label": " ", "thClass": "th-editdelete" },
		{ "label": $localize`:@@ts.action:Action`, "thClass": "th-more-client", "hidden": true }
	];
	cols: Array<object> = [
		{ 
			"key": "invoice_number", "tdClass": "td-invoice_number",
			"render": (value, row) => {
				let actionBtn = '';
				actionBtn = actionBtn + `<a href="javascript:void(0);" class="invoice_number"> ${value}</a>`;				
				if (row?.parent_invoice_id != null) {
					let invoice_number = row?.parent_invoice.invoice_number;
					actionBtn = actionBtn + `(<a href="javascript:void(0);" class="parent-invoice-number record-num"> #${invoice_number}</a>)`;
				}
				return actionBtn
			},
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('invoice_number')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
				}
				if (e.target.classList.contains('parent-invoice-number')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row.parent_invoice);
				}
			},
		},
		{
			"key": "client_name", "tdClass": "td-client",
			"render": (value) => `${value ? value : ''}`
		},
		{
			"key": "status", "tdClass": "td-payment",
			"render": (value, row) => {

				let status = i18n[value] ? i18n[value] : i18n.pending;

				// let colorClass = "highlight";

				// if (value == 'paid') {
				//   colorClass = 'success';
				// } else if (value == 'partially') {
				//   colorClass = 'warning';
				// } else if (value == 'pending') {
				//   colorClass = 'warning';
				// } else if (value == 'refund') {
				//   colorClass = 'success';
				// }

				// return `<span class="status-tag ${colorClass}">${status}</span>`
				let colorClass = "order_unpaid";
        if (row.is_draft) {
          colorClass = 'order_complete';
          status = i18n.draft;
        } else {
          if (value == 'paid') {
            colorClass = 'order_new';
          } else if (value == 'partially') {
            colorClass = 'order_preparing';
          } else if (value == 'pending') {
            colorClass = 'order_preparing';
          } else if (value == 'refund') {
            colorClass = 'order_new';
          } else if (value == 'pending_confirmation') {
            colorClass = 'order_preparing';
          }
        }

				return `<div class="${colorClass} order_status">
									<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
										<circle cx="4" cy="4" r="4" fill="#18F121"/>
									</svg>
									${status}
								</div>`
			}
		},
		{
			"key": "invoice_date", "tdClass": "td-invoice_date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (
						`<div class="date">
							<span class="day">${d.format('DD')}</span>
							<span class="month">${d.format('MMM')}</span>
							<span class="year">${d.format('YYYY')}</span>
						</div>`
					);
				}

				return '';
			}
		},
		{
			"key": "total_amount",
			"tdClass": "td-amount",
			"render": (value, row) => {
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
				return `<div class="amount">
              <span class="sar">${currency}</span>
							<span class="price">${value ? value : 0}</span>
						</div>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0) 
			} 
		},
		// {
		// 	"key": "title", "tdClass": "td-project-name",
		// 	"render": (value) => {
		// 		return `<a href="javascript:void(0);" class="proposal_title"> ${value}</a>`
		// 	},
		// 	"dataClick": (e, value?: any, row?: any) => {

		// 		if (e.target.classList.contains('proposal_title')) {
		// 			this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
		// 		}
		// 	},
		// },    
		// { 
		// 	"key": "paid_amount", 
		// 	"tdClass": "td-amount", 
		// 	"render": (value, row) => { 
		// 		// return this.containerContext.currencyPipe.transform(value ? value : 0) 
		// 		let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
		// 		return `<div class="amount">
		// 					<span class="price">${value ? value : 0}</span>
		// 					<span class="sar">${currency}</span>
		// 				</div>`
		// 	} 
		// },
		// { 
		// 	"key": "due_amount", 
		// 	"tdClass": "td-amount", 
		// 	"render": (value, row) => { 
		// 		// return this.containerContext.currencyPipe.transform(value ? value : 0) 
		// 		let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
		// 		return `<div class="amount">
		// 					<span class="price">${value ? value : 0}</span>
		// 					<span class="sar">${currency}</span>
		// 				</div>`
		//   }
		// },
		// {
		//   "key": "email_status", "tdClass": "td-status",
		//   "render": (value, row) => {

		//     let status = i18n[value] ? i18n[value] : i18n.unsent;
		//     let colorClass = 'highlight';

		//     if (value == 'viewed') {
		//       colorClass = 'success';
		//     } else if (value == 'sent') {
		//       colorClass = 'warning';
		//     }

		//     return `<span class="dot-status revealed ${colorClass}" ><i>${status}</i></span>`;
		//   }
		// },
		// {
		// 	"key": "status",
		// 	"tdClass": "td-record",
		// 	"render": (value, row) => {
		// 		let btnName = i18n.invoice.record_payment;
		// 		if (value != 'paid' && row.parent_invoice_id == null && row.pending_invoices != 1) {
		// 			return `<a href="javascript:void(0);" class="record-payment"> ${btnName}</a>`;
		// 		}

		// 		let confirmBtnName = i18n.invoice.confirm_payment;
		// 		if (value != 'paid' && row.pending_invoices == 1) {
		// 			return `<a href="javascript:void(0);" class="confirm-payment">${confirmBtnName}</a>`;
		// 		} else if (row.parent_invoice_id != null) {
		// 			let invoice_number = row.parent_invoice.invoice_number;
		// 			return `<a href="javascript:void(0);" class="parent-invoice-number record-num"> #${invoice_number}</a>`;
		// 		}
		// 		return '';
		// 	},
		// 	"dataClick": (e, value?: any, row?: any) => {
		// 		if (e.target.classList.contains('record-payment')) {
		// 			this.containerContext.invoiceActions(INVOICE_ACTIONS.RECORD_PAYMENT, row);
		// 		}
		// 		if (e.target.classList.contains('confirm-payment')) {
		// 			this.containerContext.invoiceActions(INVOICE_ACTIONS.CONFIRM_PAYMENT, row);
		// 		}
		// 		if (e.target.classList.contains('parent-invoice-number')) {
		// 			this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row.parent_invoice);
		// 		}
		// 	}
		// },
    // {
    //   "key": "uuid", "tdClass": "td-editdelete",

    //   "render": (value, row) => {
    //     let btn = '';
    //     if (row.parent_invoice_id != null) {
    //       if (row.status != 'refund') {
    //         return `<a href="javascript:void(0);" class="delete">
    //               <svg class="delete-invoice-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    //                 <g fill="none" fill-rule="evenodd">
    //                   <g fill="#FB4575">
    //                     <path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
    //                   </g>
    //                 </g>
    //               </svg>
    //             </a>
    //             <a href="javascript:void(0);" class="refund">
    //             <svg class="refund-invoice-btn"  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="19" height="19" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    //               <g>
    //                 <path d="M317.959,115.859H210.158V58.365h-44.864L0,223.66l165.294,165.294h44.864V331.46h136.548c67.367,0,122.174,54.807,122.174,122.174H512V309.9C512,202.905,424.953,115.859,317.959,115.859zM468.88,342.412c-30.253-33.206-73.82-54.071-122.174-54.071H167.038v41.78L60.981,223.661l106.057-106.057v41.375h150.921c83.219,0,150.921,67.703,150.921,150.921V342.412z"/>
    //               </g>
    //             </svg>
    //           </a>`;
    //       }
    //       return '';
    //     } else {
    //       if (row.status == 'partially') {
    //         return '';
    //       }

    //       if (row.status != 'paid') {
    //         if(row.tax_type == 3 || (row.tax_type == null && !row.tax_percent)) {
    //           return `<a href="javascript:void(0);" class="delete">
    //             <svg class="delete-invoice-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    //               <g fill="none" fill-rule="evenodd">
    //                 <g fill="#FB4575">
    //                   <path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
    //                 </g>
    //               </g>
    //             </svg>
    //           </a>
    //           <a href="javascript:void(0);" class="edit">
    //             <svg class="edit-invoice-btn" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    //               <g fill="none" fill-rule="evenodd">
    //                 <g fill="#1C6AB6">
    //                   <path d="M12.683 8.444l-2.134-2.137 1.542-1.545 2.133 2.136-1.541 1.546zM7.189 13.95l-2.357.214.209-2.343 4.447-4.453 2.134 2.137-4.433 4.445zm8.174-8.156h-.001l-2.168-2.171c-.587-.586-1.595-.614-2.15-.055L3.92 10.701c-.258.258-.418.6-.451.962l-.3 3.306c-.02.234.062.466.229.632.15.15.351.232.56.232.024 0 .048 0 .071-.003l3.302-.3c.363-.034.704-.193.961-.45l7.123-7.133c.577-.579.552-1.544-.053-2.152z" transform="translate(-875 -616) translate(96 587) translate(779 29)"/>
    //                 </g>
    //               </g>
    //             </svg>
    //           </a>`;
    //         } else {
    //           return '';  
    //         }
    //       } else if (row.parent_invoice_id == null && !row.has_credit_invoices && (row.total_amount > 0)) {
    //         let actionBtn = '';
    //         let refundButton = i18n.invoice.make_a_refund;
    //         actionBtn = actionBtn + `<a href="javascript:void(0);" class="recall-invoice">${refundButton}</a>`;

    //         if(row.tax_type == 3 || (row.tax_type == null && !row.tax_percent)) {
    //           actionBtn = actionBtn + `<a href="javascript:void(0);" class="delete">
    //             <svg class="delete-invoice-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    //               <g fill="none" fill-rule="evenodd">
    //                 <g fill="#FB4575">
    //                   <path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
    //                 </g>
    //               </g>
    //             </svg>
    //           </a>`;
    //         }
    //         return actionBtn;
    //       } else {
    //         return '';
    //       }
    //     }
    //   },
    //   "dataClick": (e, value?: any, row?: any) => {
    //     if (e.target.classList.contains('edit') || e.target.classList.contains('edit-invoice-btn')) {
    //       this.containerContext.invoiceActions(INVOICE_ACTIONS.EDIT, row);
    //       // this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
    //     }
    //     if (e.target.classList.contains('recall-invoice') || e.target.classList.contains('recall-invoice')) {
    //       this.containerContext.invoiceActions(INVOICE_ACTIONS.RE_CALL, row);
    //     }
    //     if (e.target.classList.contains('delete') || e.target.classList.contains('delete-invoice-btn')) {
    //       this.containerContext.invoiceActions(INVOICE_ACTIONS.DELETE, row);
    //     }
    //     if (e.target.classList.contains('refund') || e.target.classList.contains('refund-invoice-btn')) {
    //       this.containerContext.invoiceActions(INVOICE_ACTIONS.REFUND_PAYMENT, row);
    //     }
    //   }
    // },
    {
      "key": "uuid", "tdClass": "td-more-client",
      // "render": (value) => `<a href="javascript:void(0);" class="tu-btn-circular transparent edit-invoice-btn"><i class="edit-icon"></i></a>`,
      "render": (value, row) => {
        if (row.id == this.activeRow) {
          let actionBtn = '';
          if (row.status != 'paid') {
            if(row.tax_type == 3 || (row.tax_type == null && !row.tax_percent) || row.is_draft) {
              let editButton = i18n.edit;
              actionBtn = actionBtn + `<button class="edit-option edit-invoice open_b2b_invoice">
                            <svg class="edit-invoice" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.33325 4.66675H10.6666" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6 7.33325H10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            ${editButton}
                        </button>`;
            }
          }
          if (row.is_draft) {
            let saveInvoiceButton = i18n.invoice.save_as_invoice;
            actionBtn = actionBtn + `<button class="edit-option convert-to-invoice">
                          <svg class="edit-invoice" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M5.33325 4.66675H10.6666" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6 7.33325H10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668" stroke="#646464" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          ${saveInvoiceButton}
                      </button>`;
          }

          let pdfButton = i18n.invoice.download_pdf;
          actionBtn = actionBtn + `<button class="edit-option pdf-invoice">
                        <svg class="pdf-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.00008 11.3333L4.66675 10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        ${pdfButton}
                      </button>`;

          if (row.zatca_invoice) {
            let xmlButton = i18n.invoice.download_xml;
            actionBtn = actionBtn + `<button class="edit-option xml-invoice">
                        <svg class="xml-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.00008 11.3333L4.66675 10" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        ${xmlButton}
                      </button>`;
          }

          if (row.client_has_email) {
            let viaEmailButton = i18n.invoice.send_via_email;
            actionBtn = actionBtn + `<button class="edit-option send-email-invoice">
                          <svg class="send-email-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          ${viaEmailButton}
                        </button>`;
          }

          if ((row.order_status == 'PENDING' || row.order_status == 'UNPAID') && row.status != 'canceled' && row.order_vat == '0.00') {
            let cancelButton = i18n.invoice.cancel_invoice;
            actionBtn = actionBtn + `<button class="edit-option cancel-invoice">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4 4L12 12" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 4L4 12" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          ${cancelButton}
                        </button>`;
          }

          let viawhatsappButton = i18n.invoice.send_via_whatsapp;
          actionBtn = actionBtn + `<button class="edit-option send-whatsapp-invoice">
                        <svg class="send-whatsapp-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        ${viawhatsappButton}
                    </button>`;

          if (row.parent_invoice_id != null) {
            if (row.status != 'refund') {
              let refundButton = i18n.refund;
              let deleteButton = i18n.delete;
              actionBtn = actionBtn +  `<button class="edit-option delete-invoice">
                            <svg class="delete-invoice" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6.88672 11H9.10672" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6.33325 8.33325H9.66659" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            ${deleteButton}
                        </button>
                        <button class="edit-option refund-invoice">
                            <svg class="refund-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            ${refundButton}
                        </button>`;
            }
          } else if (row.status == 'paid' && row.parent_invoice_id == null && !row.has_credit_invoices && (row.total_amount > 0)) {
            if (row.payment_source == 'tap') {
              let refundPaymentButton = i18n.invoice.make_a_online_refund;
              actionBtn = actionBtn + `<button class="edit-option refund-online-invoice">
                              <svg class="refund-online-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              ${refundPaymentButton}
                          </button>`;
            } 
            let refundButton = i18n.invoice.make_a_refund;
            actionBtn = actionBtn + `<button class="edit-option recall-invoice">
                            <svg class="recall-invoice-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            ${refundButton}
                        </button>`;
          } else if (row.status != 'paid') {
            if(row.tax_type == 3 || (row.tax_type == null && !row.tax_percent) || row.is_draft) {
              let deleteButton = i18n.delete;
              actionBtn = actionBtn + `<button class="edit-option delete-invoice">
                              <svg class="delete-invoice" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.88672 11H9.10672" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.33325 8.33325H9.66659" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              ${deleteButton}
                          </button>`;
            }
          }
          let copyLinkButton = i18n.invoice.copy_link;
          actionBtn = actionBtn + `<button class="edit-option copy-invoice">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M5.333 10.6667L3.88667 12.1133C2.68 13.32 0.68 13.32 -0.526667 12.1133C-1.73333 10.9067 -1.73333 8.90667 -0.526667 7.7L1.92 5.25333C3.12667 4.04667 5.12667 4.04667 6.33333 5.25333C7.54 6.46 7.54 8.46 6.33333 9.66667L5.333 10.6667Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10.667 5.33333L12.1133 3.88667C13.32 2.68 15.32 2.68 16.5267 3.88667C17.7333 5.09333 17.7333 7.09333 16.5267 8.3L14.08 10.7467C12.8733 11.9533 10.8733 11.9533 9.66667 10.7467C8.46 9.54 8.46 7.54 9.66667 6.33333L10.667 5.33333Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.94678 10.0532L9.94678 6.05322" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        ${copyLinkButton}
                      </button>`;

          return `<span class="bt-content">
                <div class="position-relative">
                    <div class="options-menu">
                      ${actionBtn}                        
                    </div>
                    <div class="dots_container-rounded w-100 open-menu">
                        <svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                            <path d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
              </span>`;
        }
        return `<span class="bt-content"><div class="position-relative">
          <div class="dots_container-rounded w-100 open-menu">
            <svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
              <path d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div></span>`;
      },
      "dataClick": (e, value?: any, row?: any) => {
        console.log(e);
        if (e.target.classList.contains('edit-invoice-btn') || e.target.classList.contains('edit-icon')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
        }
        if (e.target.classList.contains('dots-menu') || e.target.classList.contains('open-menu')) {
          this.toggleActions(row.id)
        }
        if (e.target.classList.contains('edit-invoice')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.EDIT, row);
        }
        if (e.target.classList.contains('convert-to-invoice')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.SAVE_AS_INVOICE, row);
        }
        if (e.target.classList.contains('copy-invoice')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.COPY_LINK, row);
        }
        if (e.target.classList.contains('delete-invoice')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.DELETE, row);
        }
        if (e.target.classList.contains('refund-online-invoice')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.REFUND_ONLINE_PAYMENT, row);
				}
        if (e.target.classList.contains('refund-invoice') || e.target.classList.contains('refund-invoice-svg')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.REFUND_PAYMENT, row);
        }
        if (e.target.classList.contains('recall-invoice') || e.target.classList.contains('recall-invoice-svg')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.RE_CALL, row);
        }
        if (e.target.classList.contains('pdf-invoice') || e.target.classList.contains('pdf-invoice-svg')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.PDF_INVOICE, row);
        }
        if (e.target.classList.contains('xml-invoice') || e.target.classList.contains('xml-invoice-svg')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.XML_INVOICE, row);
        }
        if (e.target.classList.contains('send-email-invoice') || e.target.classList.contains('send-email-invoice-svg')) {
          this.containerContext.doAction({ action: INVOICE_ACTIONS.EMAIL, invoice: row });
        }
        if (e.target.classList.contains('send-whatsapp-invoice') || e.target.classList.contains('send-whatsapp-invoice-svg')) {
          this.containerContext.doAction({ action: INVOICE_ACTIONS.WHATSAPP, invoice: row });
        }
        if (e.target.classList.contains('cancel-invoice')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.CANCEL, row);
        }
      }
    }
    // {
    //   "key": "uuid", "tdClass": "td-more-client",
    //   "render": (value) => `<a href="javascript:void(0);" class="tu-btn-circular transparent edit-invoice-btn"><i class="edit-icon"></i></a>`,
    //   "dataClick": (e, value?: any, row?: any) => {
    //     console.log(e);
    //     if (e.target.classList.contains('edit-invoice-btn') || e.target.classList.contains('edit-icon')) {
    //       this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
    //     }
    //   }
    // }
  ];

  constructor(container: any) {
    this.containerContext = container;
  }

  // Track which row has the menu open
  activeRow: number | null = null;

  toggleActions(id: number) {
    this.activeRow = this.activeRow === id ? null : id;
    console.log([id, this.activeRow])
  }
}
